<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { usePlayerStore } from '~/stores/player'
const { t } = useI18n()
const player = usePlayerStore()
const progress = computed(() => player.duration > 0 ? Math.min(100, player.currentTime / player.duration * 100) : 0)
const time = (value: number) => `${Math.floor(value / 60)}:${Math.floor(value % 60).toString().padStart(2, '0')}`
</script>

<template>
  <div class="scrub">
    <span class="time">{{ time(player.currentTime) }}</span>
    <label class="scrubber" :style="{ '--p': `${progress}%` }">
      <span class="rail" aria-hidden="true"><i /></span><span class="knob" aria-hidden="true" />
      <input type="range" min="0" :max="player.duration || 0" step="0.1" :value="player.currentTime" :disabled="!player.duration || player.loading" :aria-label="t('ux.seek')" :aria-valuetext="`${time(player.currentTime)} / ${time(player.duration)}`" @input="player.seek(Number(($event.target as HTMLInputElement).value))" @keydown.left.prevent="player.seek(player.currentTime - 5)" @keydown.right.prevent="player.seek(player.currentTime + 5)">
    </label>
    <span class="time">{{ player.duration > 0 ? time(player.duration) : '--:--' }}</span>
  </div>
</template>
